import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import SettingsPage from '../partials/SettingsPage';
import LoadingSpinner from '../partials/LoadingSpinner';

import DisableCartLayoutModal from './DisableCartLayoutModal';

import {
  Card, BlockStack, InlineStack, Text, Button, IndexTable, Badge, Banner,
} from '@shopify/polaris';
import { PlusIcon, EditIcon, DeleteIcon } from '@shopify/polaris-icons';

import { cartLayoutsIndex } from '../../redux/actions/cartLayouts';
import { DEFAULT_CART_LAYOUT_ID } from '../../constants';


const CartLayouts = ({ cartLayouts, loadCartLayouts }) => {
  const [activeCartLayout, setActiveCartLayout] = useState(null);
  const [showDisableCartLayoutModal, setShowDisableCartLayoutModal] = useState(false);


  useEffect(() => {
    loadCartLayouts();
  }, [loadCartLayouts]);

  const showDisableModal = (id) => {
    let layout = cartLayouts.cartLayouts.find(layout => layout.id === id);

    setActiveCartLayout(layout);
    setShowDisableCartLayoutModal(true);
  }

  const actionButtons = (id) => {
    if (id === DEFAULT_CART_LAYOUT_ID) {
      return <Badge>Built-in</Badge>;
    }

    return(
      <InlineStack gap="200">
        <Link to={`/cart_layouts/edit/${id}`}>
          <Button
            icon={EditIcon}
          >
            Edit
          </Button>
        </Link>
        <Button
          onClick={() => showDisableModal(id)}
          tone="critical"
          icon={DeleteIcon}
        >
          Disable
        </Button>
      </InlineStack>
    )
  }

  return (
    <>
      <SettingsPage
        title="Cart Layouts"
        description="Have questions or need some help? Contact us at support@athousandapps.com"
      >
        <Card>
          <BlockStack gap="400">
            <Text as="h2" variant="headingMd">Cart Layouts</Text>

            { cartLayouts.status === 'success' && cartLayouts.cartLayouts.length > 0 &&
              <>
                <IndexTable
                  resourceName={{ singular: 'cart layout', plural: 'cart layouts' }}
                  itemCount={cartLayouts.cartLayouts.length}
                  selectable={false}
                  headings={[
                    { title: 'Label' },
                    { title: 'Rows' },
                    { title: 'Columns' },
                    { title: 'Actions' },
                  ]}
                >
                  {cartLayouts.cartLayouts.map((layout, index) => (
                    <IndexTable.Row id={layout.id} key={layout.id} position={index}>
                      <IndexTable.Cell>{layout.label}</IndexTable.Cell>
                      <IndexTable.Cell>{layout.rows}</IndexTable.Cell>
                      <IndexTable.Cell>{layout.columns}</IndexTable.Cell>
                      <IndexTable.Cell>{actionButtons(layout.id)}</IndexTable.Cell>
                    </IndexTable.Row>
                  ))}
                </IndexTable>
                <InlineStack align="start">
                  <Link to="/cart_layouts/new">
                    <Button
                      variant="primary"
                      icon={PlusIcon}
                    >
                      New Cart Layout
                    </Button>
                  </Link>
                </InlineStack>
              </>
            }

            { cartLayouts.status !== 'success' &&
              <LoadingSpinner size="small" statusText="Loading cart layouts"/>
            }

            { cartLayouts.status === 'success' && cartLayouts.cartLayouts.length === 0 &&
              <Banner tone="warning">
                <p>No cart layouts set. Create cart layouts to see and manage them here.</p>
                <InlineStack align="start">
                  <Link to="/cart_layouts/new">
                    <Button
                      variant="primary"
                      icon={PlusIcon}
                    >
                      New Cart Layout
                    </Button>
                  </Link>
                </InlineStack>
              </Banner>
            }
          </BlockStack>
        </Card>
      </SettingsPage>

      <DisableCartLayoutModal
        showDisableCartLayoutModal={showDisableCartLayoutModal}
        setShowDisableCartLayoutModal={setShowDisableCartLayoutModal}
        cartLayout={activeCartLayout}
        cartLayoutId={activeCartLayout?.id}
      />
    </>
  )
}

const mapStateToProps = state => ({
  cartLayouts: state.cartLayouts,
});

const mapDispatchToProps = (dispatch) => ({
  loadCartLayouts: () => dispatch(cartLayoutsIndex()),

});

export default connect(mapStateToProps, mapDispatchToProps)(CartLayouts);
